import { useQuery } from 'react-query';
import request from '../../../helpers/request';

export const getReactions = async (id) => {
  return await request.get(
    `/Information/reactions/${id}`,
    {},
    'При запросе количества просмотров и реакций произошла ошибка'
  );
};

export const createInfoReactionsKeys = (id) => ['infoReactions', id];

const useInfoReactions = (id, options) =>
  useQuery(createInfoReactionsKeys(id), () => getReactions(id), options);

export default useInfoReactions;
